import React from 'react';
import Avatar from '@mui/material/Avatar';
import useSignedFileUrl from '../helpers/authenticatedFile';

// The small round photograph in a list row.
//
// The photograph URL is signed rather than fetched, so the browser loads and
// caches it itself. Without this every row in a list would re-request the same
// image on each render.
const RecordAvatar = ({record, alt, children, ...props}) => {
    const {url} = useSignedFileUrl(record && record.photo);

    return (
        <Avatar src={url || undefined} alt={alt} {...props}>
            {children}
        </Avatar>
    );
};

export default RecordAvatar;